import React from "react";
import PropTypes from "prop-types";
import "./css/overlayButton.css";

const OverlayButton = ({
  quid,
  buttonType,
  buttonClass,
  buttonText,
  buttonAction,
  disabled
}) => (
  <button
    data-quid={quid}
    type={buttonType}
    className={`overlay-button button--${buttonClass}`}
    onClick={buttonAction}
    disabled={disabled}
  >
    {buttonText}
  </button>
);

OverlayButton.propTypes = {
  buttonType: PropTypes.string.isRequired,
  buttonClass: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonAction: PropTypes.func,
  quid: PropTypes.string.isRequired
};

OverlayButton.defaultProps = {
  buttonAction: null
};

export default OverlayButton;
